import {
	Directive,
	ElementRef,
	Input,
	inject,
	OnChanges,
	OnDestroy,
	OnInit,
	Renderer2,
	SimpleChanges
} from '@angular/core';
import { Timer } from 'go-modules/timer';
import { FormatTimePipe } from '@go-modules/pipes/format-time/format-time.pipe';

@Directive({
	selector: '[uiTimer]',
	standalone: false
})
export class UiTimerDirective implements OnInit, OnChanges, OnDestroy {
	@Input('uiTimer') public active = false;
	private timer: Timer | null = null;
	private formatTime = new FormatTimePipe();
	private elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
	private renderer = inject(Renderer2);

	public ngOnInit (): void {
		this.bindTimer();
	}

	public ngOnChanges (changes: SimpleChanges): void {
		if ('active' in changes) {
			this.updateTimerState();
		}
	}

	public ngOnDestroy (): void {
		if (!this.timer) return;

		this.timer.off(Timer.EVENT.TIME, this.handleTime);
		this.timer = null;
	}

	private bindTimer (): void {
		const timerId = this.elementRef.nativeElement.getAttribute('id');
		if (!timerId) {
			console.error('[UiTimerDirective] Missing id attribute for timer binding.');
			return;
		}

		this.timer = Timer.get(timerId);
		this.timer.on(Timer.EVENT.TIME, this.handleTime);

		this.updateText(this.timer.getTime());
		this.updateTimerState();
	}

	private updateTimerState (): void {
		if (!this.timer) return;

		if (this.active) {
			this.timer.start();
		} else {
			this.timer.pause();
		}
	}

	private handleTime = (time: number): void => {
		this.updateText(time);
	};

	private updateText (time: number): void {
		const formatted = this.formatTime.transform(time, 'timer');
		this.renderer.setProperty(this.elementRef.nativeElement, 'textContent', formatted);
	}
}
